import React, {useEffect, useState} from "react";

import "./user.modules.css"
import UserForm from "./UserForm";
import {useParams} from "react-router-dom";
import {hasPermission} from "../../../helpers/utils/AccessControlUtils";
import {fetchWithExtraOptions, tgxApi} from "../../../app/tgxApi";
import {useGetUserByIdQuery} from "./usersApi";
import Preloader from "../../../components/common/Preloader";

const UpdateUser: React.FC = () => {

    let {userId} = useParams();
    // @ts-ignore
    fetchWithExtraOptions(tgxApi.endpoints.getUserById, {userId}, {
        redirectToErrorPage: true,
        skip: !userId
    });

    const userByIdApi = useGetUserByIdQuery(userId);
    const [crumbs, setCrumbs] = useState<any[]>([]);

    useEffect(() => {
        let userObj = userByIdApi?.data?.userDTO;
        if (userObj) {
            setCrumbs([
                {content: "Home", url: "/home"},
                {content: "Users", url: "/users"},
                {content: userObj?.username, url: ""}
            ]);

            document.title = `${userObj?.username}`;
        }
    }, [userByIdApi]);

    // @ts-ignore
    return (
                <UserForm crumbs={crumbs} title={"Update User"} btnText={"Update"}
                          isReadOnly={hasPermission(["USR-U"])===false}/>
    );
};
export default UpdateUser;
